export default {
  SET_DISHES(state, dishes) {
    state.dishes = dishes;
  },
  SET_DISH(state, dish) {
    state.dish = dish;
  },
};
